import React, {Component} from 'react';
import { IntercomAPI } from 'react-intercom';

import HeaderComponent from "../../shared/header/components/HeaderComponent";
import BrandsInterector from "../../../domain/pages/brands/BrandsInterector";
import BrandsService from "../../../data/pages/brands/brandsService";
import CategoriesInterector from "../../../domain/pages/categories/CategoriesInterector";
import CategoriesService from "../../../data/pages/categories/categoriesService";
import {connect} from "react-redux";
import BrandsBoxComponent from "../../shared/brandsbox/components/BrandsBoxComponent";
import FooterComponent from "../../shared/footer/components/FooterComponent";
import MenuComponent from "../../menu/components/MenuComponent";
import LoadingComponent from "../../shared/loading/components/LoadingComponent";
import queryString from 'query-string';
import FilterBrandsComponent from "../../filtercollections/components/FilterBrandsComponent";
import SimpleTitleComponent from "../../shared/simpletitle/components/SimpleTitleComponent";



class BrandsViewComponent extends Component {

    BrandsInterector = new BrandsInterector(new BrandsService().getData());
    CategoriesInterector = new CategoriesInterector(new CategoriesService().getData());
    componentDidMount() {
      IntercomAPI('trackEvent', 'access-brand-list-page');
    }
    
    getBrands() {
        let brands = this.props.brandsData
        const qs = queryString.parse(this.props.location.search);
        if ('categories' in qs) {
            brands =  brands.filter( b => ( b.categories.filter( c => qs.categories.split(',').includes(c.toString()) ) ).length > 0 )
        }
        if ('segments' in qs) {
            brands =  brands.filter( b => b.segments.includes(parseInt(qs.segments)) )
        }
        return brands
    }
    getTitle() {
        const qs = queryString.parse(this.props.location.search);
        return ('title' in qs) ? unescape(qs.title) : "BRANDS A-Z" 
    }

    getCategories() {
        const qs = queryString.parse(this.props.location.search);
        if ('segments' in qs) {
            let brands = this.props.brandsData
            brands =  brands.filter( b => b.segments.includes(parseInt(qs.segments)) )
            
            let categories = []
            brands.forEach(element => {
                categories += element.categories
            });
            console.log(categories);

            return this.props.categoriesData.filter(
                category => categories.includes(parseInt(category.id))
            )
        }
        return this.props.categoriesData
    }

    render() {
        return (
            <div>
                <HeaderComponent />
                <MenuComponent />
                <main>
                    <section className="centerComponent">
                        <SimpleTitleComponent title={this.getTitle()} />
                    </section>
                    <section id="mainCollection" className="centerComponent">
                        
                        { this.props.location.search !== "" ?
                            <>
                            <div className="leftCollection">    
                                <FilterBrandsComponent 
                                    categories={this.getCategories()}
                                    brands={this.props.brandsData}
                                />
                            </div>
                            <div className="rightCollection">
                                {/* <SimpleTitleComponent title="OUR BRANDS" /> */}

                                { this.props.brandsData.length > 0 ? (
                                    <BrandsBoxComponent brands={this.getBrands()} />
                                ) : (
                                        <LoadingComponent />
                                    )
                                }
                            </div>
                            </>
                            :
                            <>
                                { this.props.brandsData.length > 0 ? (
                                    <BrandsBoxComponent brands={this.getBrands()} />
                                ) : (
                                        <LoadingComponent />
                                    )
                                }
                            </>
                        }
                        
                    </section>
                </main>
                <FooterComponent/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        homeData: state.homeEntity,
        brandsData: state.brandsEntity,
        categoriesData: state.categoriesEntity
    }
}

export default connect(mapStateToProps)(BrandsViewComponent);
